import React from 'react';
import './VisibilityProblem.css';

const VisibilityProblem = () => {
  return (
    <section id="visibility-problem" className="visibility-problem-section">
      <div className="container">
        <h2 className="section-title">
          Most salons don't have a growth problem.<br />
          They have a <span className="highlight">visibility problem</span>.
        </h2>

        <div className="problem-content">
          <p className="problem-intro">Owners feel it every day:</p>

          <div className="pain-points">
            <div className="pain-point">
              <div className="pain-icon">⏰</div>
              <p><strong>Your team worked 60 hours this week.</strong> Where did the money go?</p>
            </div>

            <div className="pain-point">
              <div className="pain-icon">📞</div>
              <p><strong>Calls ring, then disappear</strong></p>
            </div>

            <div className="pain-point">
              <div className="pain-icon">📋</div>
              <p><strong>Reports exist, but answers don't</strong></p>
            </div>
          </div>

          <p className="problem-summary">
            Without clear visibility, decisions become reactive — staffing, pricing, expansion,
            and investment all feel like guesses.
          </p>

          <p className="solution-statement">
            <strong>Jajoga removes the guesswork.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default VisibilityProblem;
